module.exports = __webpack_public_path__ + "img/352-white.903583b9.png";